import { StatusBar } from 'expo-status-bar';
import React, { useContext, useEffect } from 'react';
import {
  Text, View, TouchableOpacity, Platform, StyleSheet,
  SafeAreaView,
} from 'react-native';
import {
  NativeBaseProvider, Button, Box, Image,
} from 'native-base';
import { useNavigation } from '@react-navigation/native';
import { useMutation } from '@apollo/client';
import { useToast } from 'react-native-toast-notifications';
import { Formik } from 'formik';
import { TextInput } from 'react-native-paper';
import { LoginMutation } from '../../gql/user/mutation';
import { styles, ids } from '../Common.style';
import { SCREEN_NAMES } from '../../utils/constant';
import { AuthContext } from '../../context/AuthContext';
import { emailSchema } from '../../utils/yupSchema';

import { NotificationContext } from '../../context/NotificationContext';
import LoadingIndicator from '../../components/commons/LoadingIndicator';

const pageStyles = StyleSheet.create({
  formContainer: {
    width: '100%',
    marginTop: 20,
    alignItems: 'center',
  },
  inputContainer: {
    width: '90%',
    marginBottom: 15,
  },
  button: {
    width: '90%',
    marginTop: 15,
    justifyContent: 'center',
    height: 50,
  },
  forgotPassword: {
    width: '100%',
    textAlign: 'center',
    fontStyle: 'italic',
    fontSize: 12,
    marginTop: 5,
  },
});

function Login() {
  const navigation = useNavigation();
  const authContext = useContext(AuthContext);
  const notificationContext = useContext(NotificationContext);
  const [login, { data, loading, error }] = useMutation(LoginMutation);
  const toast = useToast();

  if (error) toast.show(error.message);

  useEffect(() => {
    if (data?.login && authContext) {
      authContext.setLoginSession({
        accessToken: data.login.accessToken,
        refreshToken: data.login.refreshToken,
        user: data.login.user,
      });
    }
  }, [data]);

  return (
    <SafeAreaView style={styles.container}>
      {loading && <LoadingIndicator text="Connexion en cours..." />}
      <View style={styles.Middle}>
        <Box style={styles.logoStyle} dataSet={{ media: ids.logoStyle }}>
          <Image
            style={styles.responsiveImage}
            dataSet={{ media: ids.responsiveImage }}
            roundedTop="lg"
            source={require('../../assets/logo.png')}
            alt="image"
          />
        </Box>
        <Text style={styles.mainTitle}>Connexion</Text>
        <TouchableOpacity onPress={() => navigation.navigate('Signup')}>
          <Text style={styles.signupText}> J'ai un code d'invitation</Text>
        </TouchableOpacity>

        <Formik
          initialValues={{ email: '', password: '' }}
          onSubmit={async (values) => {
            login({
              variables: {
                email: values.email,
                password: values.password,
                notificationToken: notificationContext.expoPushToken,
                platform: Platform.OS,
              },
            });
          }}
          validationSchema={emailSchema}
        >
          {({
            handleBlur, handleSubmit, values, errors, setFieldValue,
          }) => (
            <View style={pageStyles.formContainer}>
              <View style={pageStyles.inputContainer}>
                <TextInput
                  label="Email"
                  value={values.email}
                  onChangeText={(value) => setFieldValue('email', value)}
                  onBlur={handleBlur('email')}
                  left={<TextInput.Icon icon="email" />}
                  error={!!errors.email}
                />
                {!!errors.email && <Text style={styles.error}>{errors.email}</Text>}
              </View>

              <View style={pageStyles.inputContainer}>
                <TextInput
                  label="Password"
                  value={values.password}
                  onChangeText={(value) => setFieldValue('password', value)}
                  onBlur={handleBlur('password')}
                  secureTextEntry
                  left={<TextInput.Icon icon="lock" />}
                />
                <TouchableOpacity onPress={() => navigation.navigate('ForgotPassword')}>
                  <Text style={pageStyles.forgotPassword}>Mot de passe oublié ?</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => navigation.navigate(SCREEN_NAMES.PRIVACY_POLICY)}>
                  <Text style={pageStyles.forgotPassword}>Politique de confidentialité</Text>
                </TouchableOpacity>
              </View>

              <Button onPress={handleSubmit} style={[styles.buttonDesign, pageStyles.button]}>
                Se connecter
              </Button>
            </View>
          )}
        </Formik>

        <StatusBar />
      </View>
    </SafeAreaView>
  );
}

export default function LoginScreen() {
  return (
    <NativeBaseProvider>
      <Login />
    </NativeBaseProvider>
  );
}
